import script from "./gsrcm0102.vue?vue&type=script&setup=true&lang=js"
export * from "./gsrcm0102.vue?vue&type=script&setup=true&lang=js"

import "./gsrcm0102.vue?vue&type=style&index=0&id=f4b9e618&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4b9e618"]])

export default __exports__